module.exports = "./img/75c28d334c55226f84a3ab32f08d3273.jpg";